module.exports = __webpack_public_path__ + "img/edit-icon.059e5c4a.svg";